import {
  ListItem,
  Checkbox,
  FormControlLabel
} from "@material-ui/core";
import React, { useState } from "react";
import { useDrag, useDrop } from "react-dnd";
import DragIndicatorIcon from "@material-ui/icons/DragIndicator";
import styled from "styled-components";
import { COL_PREFERENCES } from "../../../../data/constants";
// import { DEFAULT_SELECTED_COLUMN_VALUES } from "../data/constants";

const IconStyle = styled.div`
  padding-left: 120px;
  padding-right: 9px;
  cursor: move;
`;

const DraggableDeviceColumn = ({
  props,
  moveItem,
  index,
  setListItem,
  listItem,
  preferencePage
}) => {
  let updatedListItems = listItem;
  const COLUMN_LABEL_MAPPING = COL_PREFERENCES[preferencePage].COLUMN_LABEL_MAPPING;
 

  const ref = React.useRef(null);

  const [, drag] = useDrag({
    type: "List",
    item: { id: index, index },
  });

  const [, drop] = useDrop({
    accept: "List",
    hover(item, monitor) {
      if (!ref.current) {
        return;
      }
      const dragIndex = item.index;
      const hoverIndex = index;

      if (dragIndex === hoverIndex) {
        return;
      }

      const hoverBoundingRect = ref.current.getBoundingClientRect();

      const hoverMiddleY =
        (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;

      const clientOffset = monitor.getClientOffset();

      const hoverClientY = clientOffset.y - hoverBoundingRect.top;

      if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
        return;
      }
      if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
        return;
      }

      moveItem(dragIndex, hoverIndex);
      item.index = hoverIndex;
    },
  });

  const onChangeHandleCheckBox = (checked) => {
    if (checked) {
      updatedListItems.push(props);
    } else {
      let deleteItemIndex = updatedListItems.indexOf(props);
      if (deleteItemIndex > -1) {
        updatedListItems.splice(deleteItemIndex, 1);
      }
    }
    updateSelectedColumns(updatedListItems);
  };
  const updateSelectedColumns = (updatedListItems) => {
    setListItem([...updatedListItems]);
  };

  drag(drop(ref));
  return (
    <>
      <ListItem
       disableGutters ref={ref} 
       data-testid={`listItem-${index}`}
      >
        <FormControlLabel control={
          <Checkbox 
            checked={listItem.includes(props)}
            color="default"
            style={listItem.includes(props) ? {color:"#0073e6"}:{color:"grey"}}
            onChange={(event) => onChangeHandleCheckBox(event.target.checked)} />
          } 
          style={{ width: "100%", paddingLeft: "16px" }}
          label={COLUMN_LABEL_MAPPING[props]} />
        <IconStyle data-testid={`hello-${index}`}>
          <DragIndicatorIcon fontSize="small" />
        </IconStyle>
      </ListItem>
    </>
  );
};

export default DraggableDeviceColumn;
